var React = require('react');

function FacebookCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":".2","cx":"28","cy":"28","r":"27","stroke":"#fff","strokeWidth":"2","key":0}),React.createElement("g",{"key":1},React.createElement("path",{"d":"M29.718 22.456a1.614 1.614 0 0 1 1.25-.382h1.7v-2.8c-.818-.103-1.641-.15-2.465-.14a4.096 4.096 0 0 0-2.986 1.092 4.068 4.068 0 0 0-1.083 3.108v2.286h-2.8v3.155h2.8v8.092h3.304v-8.092h2.744l.42-3.155h-3.21v-2.006a1.783 1.783 0 0 1 .326-1.158Z","fill":"#fff"}))]);
}

FacebookCircle.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = FacebookCircle;

FacebookCircle.default = FacebookCircle;
